import { businessCreateEmployeeProgramSaga } from './create'

export default function* employeeProgramSaga() {
  yield businessCreateEmployeeProgramSaga()
}
